module.exports = __webpack_public_path__ + "images/emoji/point_down.acfc4b9947401530c1e0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/point_down.png
// module id = X+Wz
// module chunks = 24